import { useEffect, FunctionComponent } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, EffectFade } from 'swiper';
import { TimelineMax, TweenMax } from 'gsap';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/img/landingPage/pc/');

const H2: FunctionComponent = () => {
    const { useLang, gtm } = useGlobal();
    const { t } = useLang('landingPage');

    let ScrollMagic: any;
    let controller: any;
    useEffect(() => {
        ScrollMagic = (window as any).ScrollMagic;
        controller = new ScrollMagic.Controller();
        return () => {
            (ScrollMagic = null), (controller = null);
        };
    }, []);

    useEffect(() => {
        const origin = '.scroll-trigger-origin-H2';
        const duration = window.innerHeight;
        // 时间轴动画
        const TL = new TimelineMax();
        const firstScreen = TweenMax.to(`${origin} .product-screen`, 1, { opacity: 1, ease: undefined });
        TL.add(firstScreen, 0);
        const scene = new ScrollMagic.Scene({ triggerElement: origin, triggerHook: 'onEnter', offset: 0, duration });
        scene.setTween(TL);
        controller.addScene(scene);
    }, []);

    const handleBuyNow = () => {
        try {
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: t('secH_smart_product'),
                position: `Solution Page_${t('secH_smart_title')}`,
            });
            // fb埋点
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.log(e);
        }
        window.open('https://us.ecoflow.com/products/ecoflow-delta-pro-smart-home-panel');
    };

    return (
        <section className={`H2 ${css.H2} scroll-trigger-origin-H2`}>
            <div className="sticky-box">
                <article className="product-screen from">
                    <div className={`product-desc-box`}>
                        <div className="content">
                            <div className="secH_smart_title">{t('secH_smart_title')}</div>
                            <div className="secH_smart_product">{t('secH_smart_product')}</div>
                            {[
                                'secH_smart_product_function1',
                                'secH_smart_product_function2',
                                'secH_smart_product_function3',
                                'secH_smart_product_function4',
                            ].map((tKey, index) => {
                                return (
                                    <div className="secH_smart_product_function" key={`smart_product_${index}`}>
                                        {t(tKey)}
                                    </div>
                                );
                            })}
                            <div className="secH_smart_product_desc">{t('secH_smart_product_desc')}</div>
                            <div className="secH_smart_product_btn" onClick={handleBuyNow}>
                                {t('secH_smart_product_btn')}
                            </div>
                            <div className="secH_smart_product_desc_small">{t('secH_smart_product_desc_small')}</div>
                        </div>
                    </div>
                    <div className="pic-box">
                        <Swiper pagination={{ clickable: true }} modules={[Pagination, Autoplay, EffectFade]} effect="fade" className="pic" autoplay loop>
                            <SwiperSlide>
                                <EFPic className="pageFImg" name={['product_smart.webp', 'product_smart.jpg']} />
                            </SwiperSlide>
                            <SwiperSlide>
                                <EFPic className="pageFImg scale" name={['e-1.webp', 'e-1.png']} />
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </article>
            </div>
        </section>
    );
};

export default H2;
